import { toast, ToastOptions } from 'react-toastify'
import { toastContainerId } from '../../pages/App'
import ReleaseMessageToastContent from '../../components/Toast/ReleaseMessageToastContent'
import * as React from 'react'
import { defaultToastOptions } from '../useQueueStateHandler'

const releaseMessageToastId = ''

export default function useProcessReleaseMessageNotification() {
    return () => {
        console.log('Showing an upcoming release notification')

        const options: ToastOptions<any> = {
            toastId: releaseMessageToastId,
            containerId: toastContainerId,
            ...defaultToastOptions,
            autoClose: false,
        }
        const render = () => <ReleaseMessageToastContent />

        if (toast.isActive(releaseMessageToastId, toastContainerId)) {
            toast.update(releaseMessageToastId, {
                ...options,
                render,
            })
        } else {
            toast(render, options)
        }
    }
}
